import type { GoodsRow } from "@/types/shopGoods";
import { getGoodsPricing } from "@/utils/goodsPricing";

export function goodsPriceLabel(goods: GoodsRow): string {
  const { price } = getGoodsPricing(goods);
  return `${money(price)}${goods.isMultiSpecification === 1 && price != null ? " 起" : ""}`;
}

export const goodsAuditStatuses = [
  "无需审核",
  "待审核",
  "审核通过",
  "审核驳回",
];
export const goodsTypes = [
  { label: "自营", value: 1 },
  { label: "入驻商家", value: 2 },
];
export const stockTypes = [
  { label: "现货", value: 1 },
  { label: "预售", value: 2 },
];
export const supplyTypes = [
  { label: "自营", value: 1 },
  { label: "三方供应商", value: 2 },
];
export function statusOptions(
  labels: string[]
): { label: string; value: number }[] {
  return labels.map((label, value) => ({ label, value }));
}
export function money(value: number | string | null | undefined): string {
  return value === null || value === undefined
    ? "-"
    : `¥${Number(value).toFixed(2)}`;
}

export function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "操作失败，请稍后重试";
}

export function goodsSettlementPriceLabel(goods: { skuList?: { costPrice?: number | null; status?: number | null }[] }): string {
  const skus = (goods.skuList ?? []).filter((sku) => sku.status == null || sku.status === 1);
  if (!skus.length || skus.some((sku) => sku.costPrice == null || !Number.isFinite(sku.costPrice) || sku.costPrice < 0)) return "-";
  const prices = skus.map((sku) => sku.costPrice ?? 0);
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  return min === max ? `¥${min.toFixed(2)}` : `¥${min.toFixed(2)}–¥${max.toFixed(2)}`;
}
